export default __webpack_public_path__ + "static/huiliang1-19dd6a9b3cb99db5e87131736eeb268f.jpg";